var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"red-hat-regular",attrs:{"id":"app"}},[(_vm.isActive)?_c('lco-loader'):_vm._e(),_vm._v(" "),(_vm.isMessage)?_c('lco-message',{attrs:{"message":_vm.message,"backgroundColor":_vm.backgroundColor,"leftalign":_vm.leftalign,"minwidth":_vm.minwidth,"snackbarClass":_vm.snackbarClass}}):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b37cc15","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 200
// module chunks = 354